/**
 * Production creator dashboard access.
 * Signup stores role CONTENT_CREATOR while creatorReviewStatus is still
 * PENDING_REVIEW, so role and isCreator must not be treated as certification.
 */
export const isCertifiedCreator = (auth) =>
  auth?.creatorReviewStatus === "FULL_ACCESS";
